export default "__VITE_ASSET__CTy3o9_L__"